import AuthHeader from '@/components/AuthHeader.vue';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import 'bulmaswatch/superhero/bulmaswatch.min.css';

// @ts-ignore
import VueSignaturePad from 'vue-signature-pad';

Vue.config.productionTip = false;

library.add(fas);
config.autoAddCss = false;

Vue.component('vue-fontawesome-icon', FontAwesomeIcon);
Vue.component('vue-fontawesome-layers', FontAwesomeLayers);
Vue.component('vue-fontawesome-layers-text', FontAwesomeLayersText);

Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome-icon',
  defaultIconPack: 'fas',
});

Vue.use(VueSignaturePad);

Vue.component('auth-header', AuthHeader);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
